import { Component, Renderer2 } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AwsS3MappingService } from './_services/aws-s3-mapping.service';
import jwt_decode from "jwt-decode";
import { SessionService } from './_services/session.service';
import { VASProductMgmtService } from './_services/vasprodmgmt.service';
import { LoadingService } from './_services/loading.service';
import { ConfigService } from './_services/config.service';

@Component({
  selector: 'app-root',
  template: '<block-ui><router-outlet></router-outlet></block-ui>',
  providers: [LoadingService]
})
export class AppComponent {

  title = 'Odin Connector';
  licenseCheck: boolean = false;

  jwtSession: any = {};
  partnerId: any;
  partnerAppId: any;
  reponse: any;
  isSSOEnabled: boolean;
  writeLogCheck: boolean = false;
  reponseUser: any;
  jwtToken: any;


  constructor(private configService: ConfigService,   //Need to be Executed 1st Please don't comment this
    private route: ActivatedRoute,
    private awsS3MappingService: AwsS3MappingService,
    private renderer: Renderer2,
    private session: SessionService,
    private loadingService: LoadingService,
    private vasProdMgmtService: VASProductMgmtService,
    private router: Router
    //private currRoute: ActivatedRouteSnapshot,
    //private vasProdMgmtService: VASProductMgmtService,
    //private loadingService: LoadingService,
  ) {

    console.log("App Componenet Constructor Called.");
    if (window.location.pathname.includes("/market-place/")) {


      //window.location.href;
      // if (window.location.href.indexOf("sSOToken=") != -1) {
      //   let startIndex = window.location.href.indexOf("sSOToken=")
      //   let endIndex = window.location.href.indexOf("&", startIndex)
      //   let subSSotoken = window.location.href.substring(startIndex + 9, endIndex)
      //   this.session.sSOToken = subSSotoken
      // }

      this.route.queryParams.subscribe(async params => {

        console.log("params", params);

        // // For Development Purpose
        // if (params != null && params != undefined && params['sSession'] == undefined) {
        //   let sSession = "ZXlKaGJHY2lPaUpJVXpJMU5pSjkuZXlKemRXSWlPaUowYjJ0bGJpSXNJbWxoZENJNk1UWTBNekkzTlRVMU9Dd2lhWE56SWpvaVQyRjFkR2hmUW5KdmEyVnlJaXdpZEdWdVlXNTBhV1FpT2pJME9Dd2ljMnh2WjJsdWFXUWlPaUpSVjBWU1ZERXlNelJDSWl3aWMyRndjSFJ2YTJWdUlqb2lZV1JtWnpFeU16UTFOamRrTmpSbE1HTTFOQ0lzSW5OVFpYTnphVzl1SWpvaVF6STJNRGt5TVVKQk5EQjRNREZETWtJM1F6TkNORUl4UlRBMlJrWXhOa1lpTENKemRHaHBjbVJ3WVhKMGVXbGtJam9pYm5Wc2JDSXNJbk5RWVhKMGJtVnlTV1FpT2lJd1JFUXdSamdpTENKelRtRnRaU0k2SWs1Q1ZrRlRJQ0lzSW5ORmJXRnBiQ0k2SW1GemFHbHphQzV5WVd0emFHVkFOak50YjI5dWN5NWpiMjBpTENKdVVtVnhkV1Z6ZEZSNWNHVWlPaklzSW5OVmMyVnlVbVZtU1dRaU9pSk9RakF3TURNaUxDSmxlSEFpT2pFMk5ETXpNRGd4TkRCOS5OOGQwVXNORVE4RTN2WFc1Q1VwLTRQN2pvODlubnVDM0pmaERORlRfMGpV";
        //   let decodedBase64Session = atob(sSession);
        //   this.jwtSession = jwt_decode(decodedBase64Session);
        //   localStorage.setItem('jwtToken', sSession);
        //   this.session.jwtToken = sSession;
        //   this.awsS3MappingService.jwtSession = this.jwtSession;
        //   //this.getUserSubscriptionDetails();
        // }
        //End
        //this.writeAppLog(window.location.href);
        //console.log("Route URL: ",this.route.url[0])
        if (params != null && params != undefined && params['sSession'] != undefined) {
          let ecoCallBackObject;
          let EchoBackObject
          if (params != null && params != undefined && params['secocallback'] != undefined && params['secocallback'] != "null") {
            EchoBackObject = atob(params['secocallback']);

            EchoBackObject = JSON.parse(EchoBackObject);
            ecoCallBackObject = EchoBackObject['ecoCallBackObject'];

            this.renderer.removeClass(document.body, 'theme-base');
            console.log('Echo Back Details: ', params['secocallback']);

          }
          if (ecoCallBackObject != undefined && ecoCallBackObject != null) {

            EchoBackObject = JSON.parse(EchoBackObject);
            let ecoCallBackObject1 = EchoBackObject['ecoCallBackObject'];


            this.renderer.addClass(document.body, 'theme-' + ecoCallBackObject1);
          }
          else {
            this.renderer.addClass(document.body, 'theme-base');
          }


          let sRestSession = params['sRestSession'];
          let sSession = params['sSession'];
          let decodedBase64Session = atob(sSession);
          this.jwtSession = jwt_decode(decodedBase64Session);
          this.jwtToken = atob(sSession);
          if (params.sStatusCode != undefined && params.sStatusCode == 200) {
            //localStorage.setItem('jwtToken', sSession);
            this.session.jwtToken = sSession;
            this.session.sRestSession = sRestSession;
            this.awsS3MappingService.b2cLicense = true;

            //this.getUserSubscriptionDetails();
            localStorage.clear();
            sessionStorage.clear();
          }
          // else {
          //   localStorage.setItem('sAppToken', this.jwtSession['sapptoken']);
          //   localStorage.setItem('sPartnerId', this.jwtSession['sPartnerId']);
          //   localStorage.setItem('sTenantId', this.jwtSession['tenantid']);
          // }

          localStorage.setItem('sAppToken', this.jwtSession['sapptoken']);
          localStorage.setItem('sPartnerId', this.jwtSession['sPartnerId']);
          localStorage.setItem('sTenantId', this.jwtSession['tenantid']);
          //localStorage.setItem('sAppName', this.jwtSession['secocallback']);
          localStorage.setItem('jwttoken', this.jwtToken) // BDM-3660 added authorization in header 29thMay2023 jay patil

          this.awsS3MappingService.jwtSession = this.jwtSession;


        }
        else if (params != null && params != undefined && params['sAppName'] != undefined &&
          params['sAppName'] != undefined && params['sAppName'] != undefined) {

          this.renderer.removeClass(document.body, 'theme-base');
          this.renderer.addClass(document.body, 'theme-' + params['sAppName']);

        }



        else if (params != null && params != undefined && params['sSOToken'] != undefined &&
          params['sTenantId'] != undefined && params['UserRefId'] != undefined) {

          if (params['sSOToken'] != "undefined" && params['sSOToken'] != "") {
            console.log("SSO Token Before Decoding :::: " + params['sSOToken'])
            this.session.sSOToken = decodeURIComponent(params['sSOToken']);
            console.log("SSO Token After Decoding :::: " + this.session.sSOToken)
            this.session.isSSOEnabled = true;
            if(params['groupId']!= undefined  && params['groupId'] != null){
              this.session.groupId = params['groupId'] ;
            }
            else{
              this.session.groupId = "HO" ;
            }

            let payload: any = {};
            payload.sMobileNo = "",
              payload.sEmail = params["email"],
              payload.sLoginName = params["name"],
              payload.sFirstName = "",
              payload.sLastName = "",
              payload.sTradingUserId = params["UserRefId"],
              payload.sTpUserId = "",
              payload.sPancard = params["loginId"],
              payload.sAppToken = params["sAppToken"],
              payload.sTenantId = params['sTenantId']
            //this.createVasUser(payload); //changes done for VAPT Date:- 14thAug2024 jay patil
            //console.log("log 111111111")
          }

          if (params["sTenantId"] != "undefined" && params["sTenantId"] != "") {
            this.session.sTenantId = Number(params["sTenantId"]);
          }

          if (params["UserRefId"] != "undefined" && params["UserRefId"] != "") {
            this.session.UserRefId = params["UserRefId"];
          }

          if (params["name"] != "undefined" && params["name"] != "") {
            this.session.name = params["name"];
          }

          if (params["loginId"] != "undefined" && params["loginId"] != "") {
            this.session.loginId = params["loginId"];
          }

          if (params["email"] != "undefined" && params["email"] != "") {
            this.session.email = params["email"];

          }

          if (params["sAppToken"] != "undefined" && params["sAppToken"] != "") {
            this.session.sAppToken = params["sAppToken"];

          }
          if (params["Product"] != "undefined" && params["Product"] != "") {
            this.session.Product = params["Product"];

          }



          this.getPatnerId(this.session.sTenantId)

          localStorage.clear();
          sessionStorage.clear();

          //start jay patil  Date:-07March2025 BT-155379 Fixed prod issue for ticket number 162740

          let reqPayload: any = {
            sSOToken: decodeURIComponent(params['sSOToken']),
            sUserID: params["UserRefId"],
            sProdCode: params["Product"],
            pubUrlGroupId: params["groupId"],
            sAppToken: params["sAppToken"],
            nOrgId: params["sTenantId"]
          };

          await this.checkB2CLicenseCheck(params["sTenantId"], reqPayload);

          //end jay patil  Date:-07March2025 BT-155379 Fixed prod issue for ticket number 162740
        }

        else if ((this.session.isSSOEnabled != true) && (params['sSOToken'] == undefined || params['sSOToken'] == null)) {
          this.session.isSSOEnabled = false;
          this.awsS3MappingService.b2cLicense = true;

          if (!this.writeLogCheck) {
            this.writeAppLog(window.location.href);
          }
        }

        if (params != null && params != undefined && params['sAppToken'] != undefined &&
          params['sPartnerId'] != undefined && params['sTenantId'] != undefined) {

          if (params['sAppToken'] != "undefined" && params['sAppToken'] != "") {
            localStorage.setItem('sAppToken', params['sAppToken']);
          }

          if (params['sPartnerId'] != "undefined" && params['sPartnerId'] != undefined && params['sPartnerId'] != "") {
            localStorage.setItem('sPartnerId', params['sPartnerId']);
          }

          if (params['sTenantId'] != "undefined" && params['sTenantId'] != undefined && params['sTenantId'] != "") {
            localStorage.setItem('sTenantId', params['sTenantId']);
          }

          if (params['sAppName'] != "undefined" && params['sAppName'] != undefined && params['sAppName'] != "") {
            localStorage.setItem('sAppName', params['sAppName']);
          }

          this.jwtSession.sPartnerId = params['sPartnerId'];
          this.jwtSession.tenantid = params['sTenantId'];
          this.jwtSession.appName = params['sAppName'];


          this.awsS3MappingService.jwtSession = this.jwtSession;
          //console.log("log 3333333333")
          //this.writeAppLog(window.location.href);
          //  this.checkB2CLicenseCheck(this.jwtSession.tenantid);

        }
        //start jay patil start BT-115937 5th sept 2023
        else if (params != null && params != undefined &&
          params['redirect'] != undefined && params['redirect'] != null) {
          let redirect = atob(params['redirect']);
          // console.log("redirect=", redirect);
          const redirect_Str = redirect.split('&');
          // console.log("redirect_Str=", redirect_Str);
          const result = {};

          redirect_Str.forEach((pair) => {
            const [key, value] = pair.split('=');
            result[key] = value;
          });

          // console.log("result=", result);

          if (result['sAppToken'] != undefined && result['sAppToken'] != null &&
            result['sPartnerId'] != undefined && result['sPartnerId'] != null &&
            result['sTenantId'] != undefined && result['sTenantId'] != null) {
            localStorage.setItem('sAppToken', result['sAppToken']);
            localStorage.setItem('sPartnerId', result['sPartnerId']);
            localStorage.setItem('sTenantId', result['sTenantId']);

            this.jwtSession.sPartnerId = result['sPartnerId'];
            this.jwtSession.tenantid = result['sTenantId'];
            this.awsS3MappingService.jwtSession = this.jwtSession;
          }

        }
        //end jay patil start BT-115937 5th sept 2023

        else {
          //this.writeAppLog(window.location.href);
          let sPartnerId = localStorage.getItem("sPartnerId");
          let sTenantId = localStorage.getItem("sTenantId");
          //let nRequestType = 2;//localStorage.getItem("nRequestType");
          //let sAppToken = localStorage.getItem("sAppToken");
          let sAppName = localStorage.getItem("sAppName");

          this.jwtSession.sPartnerId = sPartnerId;
          this.jwtSession.tenantid = sTenantId;
          this.jwtSession.appName = params['sAppName'];

          this.awsS3MappingService.jwtSession = this.jwtSession;
          // this.checkB2CLicenseCheck(this.jwtSession.tenantid);
        }

      })
    }
  }




  createVasUser(payload): any {
    this.vasProdMgmtService.createVasUser(payload).subscribe((res: any) => {
      this.reponseUser = res.data;
      console.log("Response from createVasUser" + this.reponseUser);
    }, err => {
      let errres: any = err.error;
      console.log("Error..While calling createVasUser", errres);
    })
  }




  writeAppLog(herf): any {
    this.vasProdMgmtService.writeAppLog(herf).subscribe((res: any) => {
      this.reponse = res.data;
      this.writeLogCheck = true;
      console.log("Resonse from writelog api " + this.reponse);
    }, err => {
      let errres: any = err.error;
      this.loadingService.hide();
      console.log("Error..While calling writeAppLog")
    }
    )
  }

  //  if (this.isSSOEnabled && this.awsS3MappingService.b2cLicense != true ) {\
  async checkB2CLicenseCheck(tenantid, reqPayload) {
    let res: any = await this.vasProdMgmtService.checkB2CLicense(tenantid)
    let value: any = res.data;
 
    if (value.nLicenseIssued != undefined && value.nLicenseIssued != null && value.nLicenseIssued > 0) {
      this.awsS3MappingService.b2cLicense = true
      //start jay patil  Date:-07March2025 BT-155379 Fixed prod issue for ticket number 162740
      if (reqPayload.sSOToken != undefined && reqPayload.sSOToken != null &&
        reqPayload.sUserID != undefined && reqPayload.sUserID != null &&
        reqPayload.sProdCode != undefined && reqPayload.sProdCode != null &&
        reqPayload.pubUrlGroupId != undefined && reqPayload.pubUrlGroupId != null &&
        reqPayload.sAppToken != undefined && reqPayload.sAppToken != null &&
        reqPayload.nOrgId != undefined && reqPayload.nOrgId != null) {
        await this.getSessionForB2C(reqPayload);
      }
      //end jay patil  Date:-07March2025 BT-155379 Fixed prod issue for ticket number 162740

    }
    else {
      this.awsS3MappingService.b2cLicense = false;
    }
    // this.vasProdMgmtService.checkB2CLicense(tenantid).subscribe(
    //   async res => {
    //     let value: any = await res.data;
    //     if (value.nLicenseIssued != undefined && value.nLicenseIssued != null && value.nLicenseIssued > 0) {

    //       // this.licenseCheck = true;
    //       this.awsS3MappingService.b2cLicense = true
    //     }
    //     else {

    //       // this.licenseCheck = false;
    //       this.awsS3MappingService.b2cLicense = false;

    //     }
    //   }, err => {
    //     let errres: any = err.error;
    //     this.loadingService.hide();
    //     console.log("Error..While calling checkB2CLicenseCheck");

    //   }

    // );

    //  }
    // else {
    //     this.licenseCheck = true;
    //     this.awsS3MappingService.b2cLicense = true
    //   }
  }

  getPatnerId(sTenantId) {
    this.vasProdMgmtService.getPartnerID(sTenantId).subscribe((res: any) => {
      this.partnerAppId = res.data;
      this.session.sPatnerID = this.partnerAppId;
      console.log("Sesssion PartnerId", res.data);
    }, err => {
      let errres: any = err.error;
      this.loadingService.hide();
      console.log("Error..While calling getPartnerID")
    }
    )
  }
  /*
  getUserSubscriptionDetails() {

    this.loadingService.show();
    this.vasProdMgmtService.getUserSubscriptionDetails(this.jwtSession.sPartnerId || '0DD0F8', this.jwtSession.sUserRefId || 'NB0003').subscribe((response: any) => {
     
      if (response.success) {
        //this.userSubscriptionDetails = response.data;
        if (response.data != "" && response.data != undefined) {
          //this.router.navigate(['market-place/subscriptions']);
          sessionStorage.setItem('user_sub_detl', JSON.stringify(response.data));
        }
        else {
          this.router.navigate(['market-place/api-details']);
        }
        
        setTimeout(() => {
          this.loadingService.hide();
        }, 500);
      }
      else {
        this.loadingService.hide();
        console.log('Unable to fetch subscription details: ', response.message);
      }
    }, err => {
      this.loadingService.hide();
      let error: any = err.error;
      //this.alertService.errorMsg(error, this.vcr);
      //alert(error);
      console.log('Error in save: ', error.message);

    });
  }
  */


  //start jay patil  Date:-07March2025  BT-155379 Fixed prod issue for ticket number 162740
  async getSessionForB2C(reqPayload) {
    try {
      this.loadingService.show();
      let odinURLResp: any = await this.vasProdMgmtService.getSession(reqPayload);
      if (odinURLResp != undefined && odinURLResp != null) {
        if (odinURLResp.success) {
          if (odinURLResp.data != null && odinURLResp.data != undefined) {
            this.loadingService.hide();
            // let Url = new URL(odinURLResp.data.publisherUrl);
            // let urlData = new URLSearchParams(Url.search);
            let sSession = odinURLResp.data.publisherUrl; //urlData.get("sSession");
            let jwtToken = atob(sSession);
            localStorage.setItem('jwttoken', jwtToken);
          }
          else {
            this.loadingService.hide();
            console.log("getSessionForB2C:" + odinURLResp.data);
          }
        }
        else {
          this.loadingService.hide();
          console.log("Error While calling getSessionForB2C:", odinURLResp);
        }
      }
      else {
        this.loadingService.hide();
        console.log("Error in getSessionForB2C:", odinURLResp);
      }
    } catch (error) {
      this.loadingService.hide();
      console.log("Error...", error);
    }
  }
  //end jay patil  Date:-07March2025 BT-155379 Fixed prod issue for ticket number 162740
}
